// import { configureStore } from "@reduxjs/toolkit";
// import { setupListeners } from "@reduxjs/toolkit/query";
import { storeQRTK } from "../services";
import { storeRedux } from "./redux";
// import { UserLoggedSlice } from "./auth";
// import { PropertyFiltersSlice } from "./real_estate/list-filters";

// export const store = configureStore({
// 	reducer: {
// 		...storeQRTK.reducer,
// 		UserLogged: UserLoggedSlice.reducer,
// 		PropertyFilters: PropertyFiltersSlice.reducer,
// 	},
// 	middleware: (getDefaultMiddleware) =>
// 		getDefaultMiddleware().concat(storeQRTK.middleware),

//   });

// setupListeners(store.dispatch);

// export type RootState = ReturnType<typeof store.getState>;
// export type AppDispatch = typeof store.dispatch;

export const STORE_OLD = {
  reducer: {
    ...storeQRTK.reducer,
    ...storeRedux.reducer
  },
  middleware: storeQRTK.middleware
};
